import React from 'react';
import { Box, Avatar, Typography, SvgIcon } from '@mui/material';
import { palette, spaces, borderRadius, boxShadows } from '../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../utils/getMuiIcon';
import getTextTruncationSx from '../../../utils/getTextTruncationSx';

export interface DocumentCardProps {
  title: string;
  subtitle?: string;
  onClick?: () => void;
  testId?: string;
  maxWidth?: string;
  isActive?: boolean;
}

const DocumentCard = React.forwardRef<HTMLDivElement, DocumentCardProps>(({
  title,
  subtitle,
  onClick,
  testId = 'document-card',
  isActive = false,
}, ref) => {
  return (
    <Box
      ref={ref}
      onClick={onClick}
      data-testid={testId}
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: spaces.xs,
        padding: spaces.sm,
        width: '100%',
        backgroundColor: palette.background.paperElevation2,
        outline: isActive ? `2px solid ${palette.primary.main}` : 'none',
        borderRadius: borderRadius.md,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s ease-in-out',
        boxSizing: 'border-box',
        boxShadow: boxShadows.elevation1,
        '&:hover': onClick ? {
          boxShadow: boxShadows.elevation2,
        } : {},
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingRight: spaces.xxs,
        }}
      >
        <Avatar
          sx={{
            width: '40px',
            height: '40px',
            backgroundColor: 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <SvgIcon
            component={getMuiIcon('documentText')}
            sx={{
              color: palette.text.secondary,
            }}
          />
        </Avatar>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          minWidth: 0,
        }}
      >
        <Typography
          variant='subtitle1'
          sx={{
            fontWeight: 500,
            lineHeight: '28px',
            width: '100%',
            color: palette.text.primary,
            ...getTextTruncationSx(1),
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            variant='caption'
            sx={{
              color: palette.text.disabled,
              width: '100%',
              ...getTextTruncationSx(1),
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
});

export default DocumentCard;

